(function () {
  function now() {
    return window.performance && performance.now ? performance.now() : Date.now();
  }

  function init(root) {
    if (!root || root.getAttribute('data-hs-marquee-init') === 'true') return;

    var run = root.querySelector('.hs-marquee__run');
    var track = root.querySelector('.hs-marquee__track');
    if (!run || !track) return;

    root.setAttribute('data-hs-marquee-init', 'true');

    var duration = parseFloat(root.getAttribute('data-speed')) || 18;
    var offset = 0;
    var last = now();
    var moving = false;

    function width() {
      return Math.max(
        track.offsetWidth || 0,
        track.scrollWidth || 0,
        Math.round((run.scrollWidth || 0) / 2)
      );
    }

    function step() {
      if (!root.isConnected) return false;
      var half = width();
      var t = now();
      var dt = t - last;
      last = t;
      if (dt < 0) dt = 16;
      if (dt > 100) dt = 16;
      if (half > 8) {
        offset += (half / (duration * 1000)) * dt;
        while (offset >= half) offset -= half;
        var value = 'translateX(' + -offset.toFixed(2) + 'px)';
        run.style.webkitTransform = value;
        run.style.transform = value;
        if (!moving) {
          moving = true;
          root.classList.add('hs-marquee--js');
        }
      }
      return true;
    }

    function loop() {
      if (!step()) return;
      window.requestAnimationFrame(loop);
    }

    window.requestAnimationFrame(loop);
    var timer = window.setInterval(function () {
      if (!step()) window.clearInterval(timer);
    }, 32);
  }

  function boot() {
    var nodes = document.querySelectorAll('.hs-marquee');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('.hs-marquee')
      : null;
    if (root) init(root);
  });
})();
